<template>
  <app-overlay no-wrap :show="busy">
    <template #overlay>
      <preloader />
    </template>
  </app-overlay>
</template>

<script setup lang="ts">
import { onBeforeUnmount, onMounted, ref } from "vue";
import { useLayoutStore } from "@/store/layout";
import AppOverlay from "@/components/v2/app-overlay";
import Preloader from "@/components/preloader";

defineOptions({
  name: "page-loader",
});

const layoutStore = useLayoutStore();
const busy = ref(false);

onMounted(() => {
  busy.value = true;
  layoutStore.setPageLoading(true);
});

onBeforeUnmount(() => {
  busy.value = false;
  layoutStore.setPageLoading(false);
});
</script>
